module.exports = __webpack_public_path__ + "img/light-background.12349835.jpg";